import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
const styles = {
    color: css({
        position: 'absolute',
        top: '2px',
        left: '2px',
        right: '2px',
        bottom: '2px',
    }),
};
export function Color({ value, style, onClick }) {
    return (_jsx("div", { onClick: onClick, css: styles.color, style: {
            background: value,
            ...style,
        } }));
}
//# sourceMappingURL=Color.js.map